import { ColumnTypes, FilterTypes } from "commons/table/Constants";
import {
  renderNotesCell,
} from "components/ReactTableColumnHelper";
import React from 'react';

import { formatDateForDisplay } from 'services/MomentUtils';
import RowActionsModal from "components/BlacklistedContact/BlacklistedContactRowActionsModal"
import { DeliveryServiceConstants } from "lookup/DeliveryServiceConstants";

export const COLUMN = {
  contactValue: "contactValue",
  contactType: "contactType",
  description: "description",
  creationDate: "creationDate",
  blacklistedBy: "createdBy",
  lastModifiedDate: "lastModifiedDate",
  lastModifiedBy: "lastModifiedBy",
};

export const CreateColumnListForBlacklistedContactsList = (
  columns = [],
  enableSortFilterForCust = true,
  onActionComplete
) => {
  const columnList = [];

  for (const element of columns) {
    switch (element) {
      case COLUMN.contactValue:
        columnList.push({
          header: "Contact",
          accessor: "contactValue",
          accessorKey: "contactValue",
          width: 150,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SearchableInput,
        });
        break;
      case COLUMN.contactType:
        columnList.push({
          header: "Type",
          accessor: "contactType",
          accessorKey: "contactType",
          width: 150,
          enableColumnFilter: true,
          columnType: ColumnTypes.Text,
          filterType: FilterTypes.SingleSelect,
          filterOptions: [
            { label: "-- All --", value: "ALL" },
            { label: "Email", value: DeliveryServiceConstants.DELIVERY_SERVICE_TYPES.EMAIL },
            { label: "Fax", value: DeliveryServiceConstants.DELIVERY_SERVICE_TYPES.FAX },
          ],
          enableSorting: false,
        });
        break;

        case COLUMN.description:
          columnList.push({
            header: "Description",
            accessor: "description",
            accessorKey: "description",
            width: 30,
            enableColumnFilter: false,
            columnType: ColumnTypes.Custom,
            customComponent: (value) => {
              return renderNotesCell(value);
            },
          });
        break;

      case COLUMN.creationDate:
        columnList.push({
          header: "Blacklisted On",
          accessor: "creationDate",
          accessorKey: "creationDate",
          width: 190,
          enableColumnFilter: true,
          enableSorting: false,
          columnType: ColumnTypes.Custom,
          filterType: FilterTypes.DateRangePicker,
          customComponent: (value, row) => {
            return formatDateForDisplay(
              row.original.creationDate
            );
          },
        });
        break;

      case COLUMN.blacklistedBy:
        columnList.push({
          header: "Blacklisted By",
          accessor: "createdBy",
          accessorKey: "createdBy",
          width: 190,
          enableColumnFilter: false,
          columnType: ColumnTypes.Text,
          enableSorting: false,
        });
        break;

      case COLUMN.lastModifiedDate:
        columnList.push({
          header: "Last Modified",
          accessor: "lastModifiedDate",
          accessorKey: "lastModifiedDate",
          width: 190,
          enableColumnFilter: true,
          enableSorting: false,
          columnType: ColumnTypes.Custom,
          filterType: FilterTypes.DateRangePicker,
          customComponent: (value, row) => {
            return formatDateForDisplay(
              row.original.lastModifiedDate
            );
          },
          
        });
        break;

      case COLUMN.lastModifiedBy:
        columnList.push({
          header: "Modified By",
          accessor: "lastModifiedBy",
          accessorKey: "lastModifiedBy",
          width: 190,
          enableColumnFilter: false,
          columnType: ColumnTypes.Text,
          enableSorting: false,
        });
        break;
    }
  }

  columnList.push({
    header: "Actions",
    accessor: "actions",
    accessorKey: "actions",
    width: 120,
    enableSorting: false,
    enableColumnFilter: false,
    columnType: ColumnTypes.Custom,
    customComponent: (value, row) => (
      <RowActionsModal
        contactValue={row.original.contactValue}
        contactType={row.original.contactType}
        contactUuid={row.original.blacklistedContactUuid}
        description={row.original.description}
        onActionComplete={onActionComplete}
      />
    ),
  });
  return columnList;
};